var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full px-8"},[_c('ListMenuBar',{attrs:{"search-placeholder-label":"Search subscription","main-context-button-label":"New Subscription","main-context-button-target":{
      name: 'route.dashboard.subscription.editor.create'
    },"use-main-context-button":""}}),_c('div',{staticClass:"px-12 py-12 my-8 bg-white rounded"},[_c('ListTableSimple',{attrs:{"items":_vm.items,"columns":_vm.columns,"on-row-click-target":{
        name: 'route.dashboard.subscription.overview',
        targetColumn: 'id'
      }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }